

exports.__esModule = true;
var BUYNOW_WA_TYPE = exports.BUYNOW_WA_TYPE = 'BuyNow';
var SHOPPINGCART_WA_TYPE = exports.SHOPPINGCART_WA_TYPE = 'ShoppingCart';
var EN_DEFAULTS = exports.EN_DEFAULTS = {
    'CH': 'en_US',
    'ID': 'en_US',
    'JP': 'en_US',
    'PT': 'en_US',
    'TH': 'en_GB'
};


//////////////////
// WEBPACK FOOTER
// ./js/lib/constants.js
// module id = ./js/lib/constants.js
// module chunks = 1